import React, { useEffect } from 'react';
import { useConfig } from '../../DataStore/ConfigContext';
import { exportVouchersCSV } from '../../util/csv';

const FiltersBar = ({ filters, setFilters, handleFilter, disableSource = false , data}) => {
  const { wifiPlans, getWifiPlans } = useConfig();

  const handleExport = () => {
    if(!Array.isArray(data) || data.length === 0) {
      alert('No data available for export.');
      return;
    }
    exportVouchersCSV(data);
  }

  useEffect(() => {
    getWifiPlans();
  }, [getWifiPlans]);

  const renderPlanOptions = () => {
    if(Array.isArray(wifiPlans)) {
      return wifiPlans.map(plan => (
        <option key={plan.id} value={plan.id}>
          {plan.name}
        </option>
      ));
    }
    return <></>
  };

  return (
    <div className="card mb-3">
      <div className="card-body">
        <div className="form-row align-items-end">
          <div className="form-group col-md-3">
            <label className="small mb-1">Search</label>
            <input
              type="text"
              className="form-control"
              placeholder="Code, MSISDN, created by…"
              value={filters.q}
              onChange={(e) => setFilters((f) => ({ ...f, q: e.target.value }))}
            />
          </div>
          <div className="form-group col-md-2">
            <label className="small mb-1">Plan</label>
            <select
              className="form-control"
              value={filters.plan}
              onChange={(e) => setFilters((f) => ({ ...f, plan_id: e.target.value }))}
            >
              <option value="">All plans</option>
              {renderPlanOptions()}
            </select>
          </div>
          <div className="form-group col-md-2">
            <label className="small mb-1">Status</label>
            <select
              className="form-control"
              value={filters.status}
              onChange={(e) => setFilters((f) => ({ ...f, status: e.target.value }))}
            >
              <option value="">All</option>
              <option value="unused">Unused</option>
              <option value="used">Used</option>
              <option value="expired">Expired</option>
              <option value="revoked">Revoked</option>
              <option value="refunded">Refunded</option>
            </select>
          </div>
          <div className="form-group col-md-2">
            <label className="small mb-1">Source</label>
            <select
              className="form-control"
              disabled={disableSource}
              value={filters.source}
              onChange={(e) => setFilters((f) => ({ ...f, source: e.target.value }))}
            >
              <option value="">All</option>
              <option value="momo">Mobile Money</option>
              <option value="manual">Manual</option>
            </select>
          </div>
          <div className="form-group col-md-3">
            <label className="small mb-1">Date Range</label>
            <div className="d-flex">
              <input
                type="date"
                className="form-control mr-2"
                value={filters.from}
                onChange={(e) => setFilters((f) => ({ ...f, from: e.target.value }))}
              />
              <input
                type="date"
                className="form-control"
                value={filters.to}
                onChange={(e) => setFilters((f) => ({ ...f, to: e.target.value }))}
              />
            </div>
          </div>

          <div className="form-group col-md-12 mt-2 mb-0 d-flex">
            <button className="btn btn-primary mr-2" onClick={handleFilter}>
              <i className="fas fa-sync-alt mr-1" /> Apply
            </button>
            <button
              className="btn btn-outline-secondary"
              onClick={() =>
                setFilters({ q: '', plan: '', status: '', source: '', from: '', to: '' })
              }
            >
              Reset
            </button>
            <div className="ml-auto">
              <button className="btn btn-outline-secondary mr-2" onClick={handleExport}>
                <i className="fas fa-file-export mr-1" />
                Export CSV
              </button>
              
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FiltersBar;